import Toastr from "../../../itrust_common/components/Toastr"

const parent = 'PUBLIC_'

const DEFAULT_STATE = {
  procedure_pricings: [],
}
let changes = null;
export default function procedureReducer(state = DEFAULT_STATE, action){
  const response = action.payload && (action.payload.data || action.payload.response)
  switch(action.type){
    case `${parent}PROCEDURES_LOAD_PENDING`:
      return {...state, saving: true};

    case `${parent}PROCEDURES_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return {...state, saving: false};

    case `${parent}PROCEDURES_LOAD_FULFILLED`:
      changes = {
        ...response,
      };
      return {...state, ...changes, saving: false};
    
    default:
      return state;
  }
}